/**
 * Crockford-Base32 ULID = 26 chars, no IL O U.
 * Backend may emit prefixed forms (e.g. `bot_01KQ85Z5HWFG7TTFVNW2WWHR1G`,
 * `usr_…`). Accept both raw and prefixed.
 */
const ULID_PATTERN = /^(?:[a-z]+_)?[0-9A-HJKMNP-TV-Z]{26}$/;

export function isValidUlid(id: string | undefined | null): id is string {
  if (!id) return false;
  return ULID_PATTERN.test(id);
}
